import { defineMessages } from 'react-intl';

export default defineMessages({
    futureRepaymentsTitle: {
        id: '_.outstanding_view.futureRepaymentsTitle',
        defaultMessage: 'Next repayment'
    },
    futureRepayments: {
        id: '_.outstanding_view.futureRepayments',
        defaultMessage:
            "We'll automatically take your next repayment of {repaymentAmount} in {timeToRepayment} days"
    },
    futureRepaymentsCTA: {
        id: '_.outstanding_view.futureRepaymentsCTA',
        defaultMessage: 'Check your schedule'
    },
    manualRepayments: {
        id: '_.outstanding_view.manualRepayments',
        defaultMessage:
            'You do not have an active direct debit procedure. Please transfer your next repayment of {repaymentAmount} manually to iwoca by {repaymentDate}.'
    },
    download: {
        id: '_.outstanding_view.repayments_schedule.download_button',
        defaultMessage: 'Download'
    }
});
